import { useQuery } from "react-query";

const useUsersList = (getUsers, fetchData) => {
	const { page, filters, sortBy } = fetchData;

	const fetchUsersList = () => {
		return getUsers({
			page,
			sortBy,
			filters,
		});
	};

	const queryResult = useQuery(
		["usersList", { page, sortBy, filters }],
		fetchUsersList,
		{
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useUsersList;
